
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11A11 11 0 0012 1zm.887 14.73c-.83-.063-1.18-.489-1.833-.872-.36 1.88-.797 3.683-2.095 4.624-.4-2.842.587-4.976 1.046-7.242-.782-1.318.096-3.97 1.746-3.318 2.031.805-1.76 4.89.787 5.412 2.657.536 3.742-4.61 2.095-6.284-2.381-2.415-6.93-.054-6.37 3.402.136.846 1.009 1.103.349 2.269-1.523-.337-1.978-1.54-1.919-3.141.095-2.623 2.357-4.459 4.625-4.713 2.87-.32 5.564 1.053 5.935 3.752.416 3.048-1.298 6.346-4.366 6.111z","fill":"currentColor"}})])
          )
        }
      }
    